import { render } from "./search-input.vue?vue&type=template&id=45858cc4&ts=true"
import script from "./search-input.ts?vue&type=script&lang=ts&external"
export * from "./search-input.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__